import { gql } from '@apollo/client'

import {
  INVENTORY_ORDER_FIELDS,
  INVENTORY_ORDER_ITEM_FIELDS,
} from '../fragments'

export const ADD_INVENTORY_ORDER_ITEM_RECEIPTS = gql`
  ${INVENTORY_ORDER_ITEM_FIELDS}
  mutation AddInventoryOrderItemReceipts(
    $input: AddInventoryOrderItemReceiptsInput!
  ) {
    addInventoryOrderItemReceipts(input: $input) {
      ...InventoryOrderItemFields
    }
  }
`

export const UPDATE_INVENTORY_ORDER_NOTES = gql`
  ${INVENTORY_ORDER_FIELDS}
  mutation UpdateInventoryOrderNotes($input: UpdateInventoryOrderNotesInput!) {
    updateInventoryOrderNotes(input: $input) {
      ...InventoryOrderFields
    }
  }
`
